import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    apiURL: '',
    currentUser: {},
    refreshCnt: 0,
    refreshPage: ''
  },
  mutations: {
    resetRefreshCnt (state){
      state.refreshCnt = 0
    },
    refreshCntIncrement (state, { page }){
      state.refreshCnt++
      state.refreshPage = page + ':' + state.refreshCnt
    },
    setUserSettings (state, { data }) {
      state.currentUser.user_details.settings = data
    },
    setApiUrl (state, { url }) {
      state.apiURL = url
    },
    setCurrentUser (state, { currentUser }) {
      state.currentUser = currentUser
      state.signedIn = true
    },
    setForUpdateDetails (state, { stat }) {
      state.currentUser.user_details.change_tmp_password = stat
    },
    setForChangePassword (state, { stat }) {
      state.currentUser.user_details.request_new_pass = stat
    },
    setFnameLname (state, { user }) {
      state.currentUser.user_details.first_name = user.first_name
      state.currentUser.user_details.last_name = user.last_name
    },
    setCurrentUserPhoto (state, { photo }) {
      state.currentUser.user_details.photo = photo
    },
    unsetCurrentUser (state) {
      state.currentUser = {}
      state.signedIn = false
    }
  },
  getters: {
    getApiURL (state) {
      return state.apiURL
    },
    forReferralVerification: (state) => (referral) => {

      if((referral.from_import == 1 || referral.from_seller_import == 1) && referral.verified == 0){
        return true
      }else{
        return false
      }
    },
    getRefreshPage: (state) => () => {
      return state.refreshPage
    },
    submittedAgo: (state) => (referral) => {

      let retVal = '';
      if(referral.valid == 1 && referral.expiring == 1){
        retVal = 'Expiring '

        if (referral.expiring_in == 0){
          retVal += 'today'
        }else if (referral.expiring_in == 1){
          retVal += 'tomorrow'
        }else{
          retVal += 'in ' + referral.expiring_in + (referral.expiring_in > 1 ? ' days' : ' day')
        }
      }else if(referral.pending == 1){
        retVal = 'Submitted '

        if (referral.submitted_ago == 0){
          retVal += 'today'
        }else{
          retVal += referral.submitted_ago + (referral.submitted_ago > 1 ? ' days' : ' day') + ' ago'
        }
      }else if(referral.valid == 1){
        retVal = 'Valid';
      }else if(referral.archive == 1){
        retVal = 'Archived';
      }
      //
      // if(days > 1){
      //   retVal+= 's'
      // }
      // retVal+= ' ago'
      return retVal
    },
    classReferralStatus: (state) => (referral) => {
      return {
        expiring: referral.expiring == 1 ? true : false,
        valid: referral.valid == 1 && referral.expiring == 0 ? true : false,
        pending: referral.pending == 1 ? true : false,
        archive: referral.archive == 1 ? true : false
      }
    },
    classReferralBg: (state) => (referral) => {
      return {
        bgExpiring: referral.expiring == 1 ? true : false,
        bgValid: referral.valid == 1 && referral.expiring == 0 ? true : false,
        bgPending: referral.pending == 1 ? true : false,
        bgArchive: referral.archive == 1 ? true : false
      }
    },
    classReferralColValid: (state) => (referral) => {
      return {
        colExpiring: referral.expiring == 1 ? true : false,
        colValid: referral.valid == 1 ? true : false,
        colPending: referral.pending == 1 ? true : false,
        colArchive: referral.archive == 1 ? true : false
      }
    },
    formatFullName: (state) => (fName, lName) => {
      if(!fName){
        return ''
      }
      return fName.charAt(0).toUpperCase() + fName.slice(1) + ' ' + lName.charAt(0).toUpperCase() + lName.slice(1)
    },
    forArchive: (state) => (referral) => {
      return referral.archive == 0 ? true : false
    },
    getFirstName (state) {
      let user_details = state.currentUser.user_details
      return user_details.first_name.charAt(0).toUpperCase() + user_details.first_name.slice(1)
    },
    getTeam (state) {
      return state.currentUser.team
    },
    getChannel (state) {
      return state.currentUser.channel
    },
    getCurrentUserMenuName (state) {
      if(!state.signedIn){
        return ''
      }
      let user_details = state.currentUser.user_details
      let retVal = user_details.first_name.charAt(0) + '. ' + user_details.last_name.replace(/(?:^|\s|-)\S/g, x => x.toUpperCase())
      if (user_details.first_name.length == 0){
        retVal = user_details.email
      }
      return retVal
    },
    getCurrentUserDetails (state) {
      return state.currentUser.user_details
    },
    getUserSettings (state) {
      return state.userSettings
    },
    getCurrentUserRole (state) {
      if(!state.signedIn){
        return ''
      }
      return state.currentUser.user_details.role
    },
    getCurrentUserPhoto (state) {
      if(state.currentUser.user_details.photo == null || state.currentUser.user_details.photo.length == 0){
        return ''
      }
      return state.currentUser.user_details.photo
    },
    getPhoto: (state) => (photo) => {
      if(photo == null || photo == 0){
        return ''
      }
      return photo
    },
    forUpdateDetails (state) {
      if(state.signedIn){
        return state.currentUser.user_details.change_tmp_password
      }
      return 0
    },
    forSetPassword (state) {
      if(state.signedIn){
        return state.currentUser.user_details.request_new_pass
      }
      return 0
    },
    isTemporaryEmail: (state) => (email) => {
      return email.substr(email.length - 19) == '@tmpimportemail.com' ? true : false
    },
  },
  actions: {

  },
  plugins: [createPersistedState()]
})
